import { usePreferences } from "@/composables/usePreferences";

const { getPreferences, setPreferences, removePreferences } = usePreferences();

export const useAssistantStorage = () => {
  const assistantStorage = {
    getItem(key: string) {
      const value = getPreferences(key);
      return value;
    },
    setItem(key: string, value: string) {
      setPreferences(key, value);
    },
    removeItem(key: string) {
      removePreferences(key);
    },
  };

  return {
    assistantStorage,
  };
};
